import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import CrossIconPath from "../../../wrappers/FixaSSRIcon/paths/CrossIconPath";
import { Filter, FilterValue } from "../../types/filter";
interface AppliedCheckboxPillProps {
  filter: Filter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  filterValue: boolean;
}

export const AppliedCheckboxPill = ({
  filter,
  filterValues,
  setFilterValues,
  filterValue,
}: AppliedCheckboxPillProps) => {
  if (!filterValue) return null;

  return (
    <FixaPill
      id={filter.id}
      label={filter.title}
      size="small"
      selected
      trailingIcon={CrossIconPath}
      onClick={() => {
        setFilterValues(
          filterValues.filter((value) => value.filterId !== filter.id)
        );
      }}
    />
  );
};
